<template>
  <div class="main">
    <div class="transaction-list">
      <h1 class="title">Bills</h1>
      <div class="row">
        <div class="container">
          <!-- Form for filtering transactions -->
          <div class="form-group">
            <label for="partyname">Party *</label>
            <v-select :clearable="false" id="partyname" v-model="formData.partyname" :options="party" label="short_name"
              :reduce="party => party.autoid" selectOnTab="True" />
          </div>
          <div class="form-group">
            <label for="fromdate">Report From Date *</label>
            <input type="date" id="fromdate" v-model="formData.fromdate"
              :max="new Date().toLocaleDateString('en-ca')" />
          </div>
          <div class="form-group">
            <label for="todate">Report To Date *</label>
            <input type="date" id="todate" v-model="formData.todate" :max="new Date().toLocaleDateString('en-ca')" />
          </div>
          <div class="form-group">
            <label for="contnumber">Container No</label>
            <input type="text" id="contnumber" v-model="formData.contnumber"
              placeholder="Generating Report for Specific Container(s)..." />
          </div>
          <!--<div class="form-group">
            <label for="reporttype">Report Type *</label>
            <select id="reporttype" v-model="formData.reporttype">
              <option value="0" selected>Select Report Type</option>
              <option value="1">Survey</option>
              <option value="2">Comparator</option>
              <option value="3">Non-Eor</option>
            </select>
          </div>-->
          <div class="form-group" style="width: 100%; display: flex; justify-content: space-between;">
            <div style="width: 20%; height: 20%;margin-top: 20px;margin-right: 10%;">
              <button type="button" class="excel-button" @click="getBills" :disabled="isSubmitting">Show Result</button>
              <button type="button" class="cancel-button1" @click="resetForm" :disabled="isSubmitting">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="controls">
        <div class="search-container">
          <input v-model="searchQuery" placeholder="Search..." />
          <i class="fas fa-search search-icon"></i>
        </div>
        <div class="actions">
          <button class="export-button" title="Export to CSV" @click="exportToCSV" :disabled="isSubmitting">
            <i class="fas fa-ellipsis-v"></i>
            <ul class="export-options">
              <li>Export to CSV</li>
            </ul>
          </button>
        </div>
      </div>

      <div v-if="isLoading">Loading transactions...</div>

      <div v-else>
        <div class="table-container">
          <table class="transaction-table  table-danger">
            <thead>
              <tr>
                <th @click="sortByColumn('billno')">Bill No</th>
                <th @click="sortByColumn('billdate')">Bill Date</th>
                <th @click="sortByColumn('applicantname')">Applicant Name</th>
                <th @click="sortByColumn('accountname')">Account Name</th>
                <th @click="sortByColumn('companyid')">Company Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bill) in paginatedBills" :key="bill.autoid">
                <td>{{ bill.billno }}</td>
                <td>{{ formatDate(bill.billdate) }}</td>
                <td>{{ bill.applicantname }}</td>
                <td>{{ bill.accountname }}</td>
                <td>{{ companyMap[bill.companyid] || 'Unknown' }}</td>
                <td>
                  <div v-if="bill.filename != null">
                    <button @click="printBill(bill.filename)" class="pdf-button" :disabled="isSubmitting">
                      <i class="fas fa-file-pdf"></i> View PDF
                    </button>
                  </div>
                </td>
                <td>
                  <button @click="openEditModal(bill)" class="edit-button" :disabled="isSubmitting">
                    <i class="fas fa-edit"></i> Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bottom-controls">
          <div class="rows-per-table">
            <button v-for="option in [10, 20, 30]" :key="option" :class="{ 'active': rowsPerPage === option }"
              @click="setRowsPerPage(option)">
              {{ option }}
            </button>
          </div>
          <div class="pagination">
            <button @click="goToPage(page)" v-for="page in totalPages" :key="page"
              :class="{ 'active': currentPage === page }" class="page-number">{{ page }}</button>
          </div>
        </div>

        <div v-if="isModalVisible" class="edit-overlay">
          <div class="edit-overlay-content">
            <span class="close-btn" @click="closeModal">&times;</span>
            <h2>Container Inspection Report</h2>
            <div class="row">
              <h3 style="width: 150px;">Bill No: {{ billno }} </h3>
              <fieldset style="padding:2px;width: 400px;">
                <legend>Add Report No To Bill:(Using ,)</legend>
                Report Nos : <input type="text" placeholder="Report Nos" v-model="rptnos" style="width: 200px;"> <button @click="AddReportsTobill(billno)" class="excel-button"
                  :disabled="isButtonDisabled || isSubmitting">Update</button>
              </fieldset>
              <fieldset style="padding:2px;width: 320px;">
                <legend>Update Billdate:</legend>
                Bill Date : <input type="text" placeholder="DD/MM/YYYY" v-model="billdate" style="width: 150px;"
                  v-on:blur="checkIsDate()"> <button @click="UpdateBillDate(billno)" class="excel-button"
                  :disabled="isButtonDisabled || isSubmitting">Update</button>
              </fieldset>
              <fieldset style="padding:2px;width: 200px;">
                <legend>Update round-off:</legend>
                Bill Date : <input type="checkbox" v-model="isRound"> <button @click="UpdateBillRoundOffStatus(billno)"
                  class="excel-button" :disabled="isButtonDisabled || isSubmitting">Update</button>
              </fieldset>
            </div>
            <div class="table-container">
              <table class="transaction-table">
                <thead>
                  <tr>
                    <th>Report no</th>
                    <th>Date</th>
                    <th>Clear</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="report in reports" :key="report.rptno">
                    <td>{{ report.rptno }}</td>
                    <td>{{ formatDate(report.rptdate) }}</td>
                    <td><button @click="clearReportFromBill(report.billno, report.rptno)" class="edit-button" :disabled="isSubmitting">
                        <i class="fas fa-edit"></i> Clear
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Save and Cancel buttons -->
              <div class="form-buttons">
                <button type="button" class="cancel-button" @click="closeModal" :disabled="isSubmitting">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      bills: [],
      companyMap: {},  // To map company IDs to names
      isLoading: false,
      searchQuery: '',
      rowsPerPage: 10,
      currentPage: 1,
      party: JSON.parse(localStorage.getItem('party')),
      rptdate: new Date().toLocaleDateString('en-ca'),
      formData: {
        applicantid: 0,
        accountid: 0,
        partyname: 0,
        fromdate: '',
        todate: '',
        contnumber: '',
        reporttype: 0
      },
      sortDirection: {
        billno: 'desc',
        billdate: 'desc',
        applicantname: 'asc',
        accountname: 'asc',
        companyid: 'asc',
      },
      reports: [],
      isModalVisible: false, // Control visibility of the modal
      billdate: null,
      rptnos: null,
      billno: null,
      isButtonDisabled: false,
      isRound: false,
      isSubmitting: false
    };
  },
  computed: {
    filteredBills() {
      if (!this.bills) {
        return [];
      }
      return this.bills.filter(bill => {
        return Object.values(bill).some(value =>
          String(value).toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }).sort((a, b) => {
        for (const key in this.sortDirection) {
          if (a[key] < b[key]) return this.sortDirection[key] === 'asc' ? -1 : 1;
          if (a[key] > b[key]) return this.sortDirection[key] === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },
    paginatedBills() {
      if (!this.bills) {
        return [];
      }
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredBills.slice(start, end);
    },
    totalPages() {
      if (!this.bills) {
        return 0;
      }
      return Math.ceil(this.filteredBills.length / this.rowsPerPage);
    },
  },
  methods: {
    checkIsDate() {
      if (this.billdate != '') {
        if (cs.isvalidDate(this.billdate) == false) {
          useToast().error('Invalid From Date');
        }
      }
    },
    updateNewContainerIds(value) {
      const AppAcc = cs.GetAppAccFromParty(value)
      this.formData.applicantid = AppAcc.applicantid
      this.formData.accountid = AppAcc.accountid
    },
    async getBills() {
      if (this.isSubmitting) return;      
      const toast = useToast();      
      this.isSubmitting = true;
      this.isLoading = true;
      
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        
        this.updateNewContainerIds(this.formData.partyname)
        const transactionData = {
          applicant: this.formData.applicantid,
          account: this.formData.accountid,
          fromdate: this.formData.fromdate,
          todate: this.formData.todate,
          contnumber: this.formData.contnumber
        }
        if (transactionData.location == "") {
          transactionData.location = 0;
        }
        
        const response = await axios.get('/all_bills?applicant=' + transactionData.applicant + '&account=' + transactionData.account + '&fromdate=' + transactionData.fromdate + '&todate=' + transactionData.todate + '&contnumber=' + transactionData.contnumber, config);
        console.log(response)
        this.bills = response.data[2];
        await this.loadCompanyList();  // Load company names after fetching bills
        toast.success('Bills loaded successfully!');
      } catch (error) {
        console.error('Error fetching bills:', error);
        toast.error(error.response?.data?.message || 'Error fetching bills.');
      } finally {
        this.isLoading = false;
        this.isSubmitting = false;
      }
    },
    async printBill(filename) {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          useToast().error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const urlpath = `/printbillpdf?filename=${filename}`;
        console.log(urlpath)
        const response = await axios.get(urlpath, config);
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(pdfBlob);
        window.open(url);

      } catch (error) {
        console.error('Error generating report:', error);
        useToast().error('Error generating PDF report.');
      } finally {
        this.isSubmitting = false;
      }
    },
    async loadCompanyList() {
      const token = localStorage.getItem('access_token');
      if (!token) {
        useToast().error('Authentication token not found.');
        return;
      }
      
      const config = {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      };
      try {
        const response = await axios.get('/company_list', config);
        const companies = response.data[2];
        this.companyMap = companies.reduce((map, company) => {
          map[company.companyid] = company.companyname;
          return map;
        }, {});
      } catch (error) {
        console.error('Error fetching company list:', error);
        useToast().error(error.response?.data?.message || 'Error fetching company list.');
      }
    },
    exportToCSV() {
      if (this.isSubmitting) return;
      
      if (!this.filteredBills || this.filteredBills.length === 0) {
        useToast().error('No data to export.');
        return;
      }
      
      try {
        const headers = [
          "Bill No", "Bill Date", "Applicant Name", "Account Name", "Company Name"
        ];

        const csvContent = [
          headers.join(","),
          ...this.filteredBills.map(bill =>
            headers.map(header => JSON.stringify(bill[header.toLowerCase()] || '')).join(",")
          )
        ].join("\n");

        const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "bills.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        useToast().success('CSV exported successfully!');
      } catch (error) {
        console.error('Error exporting CSV:', error);
        useToast().error('Error exporting CSV.');
      }
    },
    setRowsPerPage(option) {
      this.rowsPerPage = option;
    },
    goToPage(page) {
      this.currentPage = page;
    },
    sortByColumn(column) {
      this.sortDirection[column] = this.sortDirection[column] === 'asc' ? 'desc' : 'asc';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    async getReportDetails(billno) {
      const token = localStorage.getItem('access_token');
      if (!token) {
        useToast().error('Authentication token not found.');
        return;
      }
      
      const config = {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      };
      try {
        const response = await axios.get('/get_reports_by_billno?billno=' + billno, config);
        console.log(response)
        this.reports = response.data[2];
      } catch (error) {
        console.error('Error fetching report details:', error);
        useToast().error(error.response?.data?.message || 'Error fetching report details.');
      }
    },
    async openEditModal(bill) {
      if (this.isSubmitting) return;
      
      console.log(bill)
      this.billdate = this.formatDate(bill.billdate);
      this.billno = bill.billno; // Store the bill number
      this.isRound = bill.isround=="\u0001"? true : false; // Set isRound based on the bill data      
      this.getReportDetails(bill.billno)
      this.isModalVisible = true; // Show the modal
    },
    closeModal() {
      if (this.isSubmitting) return;
      
      this.isModalVisible = false; // Hide the modal
      //this.isAddModalVisible = false;
      this.reports = null; // Reset selected transaction
      this.getBills(); // Fetch bills on component mount
    },

    async clearReportFromBill(billno, rptno) {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          useToast().error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        
        const response = await axios.get('/clear_report_from_bill?rptno=' + rptno + '&billno=' + billno, config);
        console.log(response)
        useToast().success(response.data[1]);
        this.getReportDetails(billno)
      } catch (error) {
        console.error('Error clearing report:', error);
        useToast().error('Error clearing report from bill.');
      } finally {
        this.isSubmitting = false;
      }
    },
    async AddReportsTobill(billno) {
      if (this.isSubmitting) return;
      
      const toast = useToast();
      
      try {
        if (this.billno == null || this.billno == '') {
          toast.error('Please enter a valid Bill No');
          return;
        }
        if (this.rptnos == null || this.rptnos == '') {
          toast.error('Please enter valid Report Nos');
          return;
        }
        
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        
        this.isButtonDisabled = true
        const response = await axios.get('/add_reports_to_bill?rptno=' + this.rptnos + '&billno=' + billno, config);
        console.log(response)
        toast.success(response.data[1]);
        this.getReportDetails(billno)
      } catch (error) {
        console.error('Error adding reports to bill:', error);
        toast.error(error.response?.data?.message || 'Error adding reports to bill.');
      } finally {
        this.isButtonDisabled = false
      }
    },
    async UpdateBillDate(billno) {
      if (this.isSubmitting) return;
      
      const toast = useToast();
      
      try {
        if (this.billno == null || this.billno == '') {
          toast.error('Please enter a valid Bill No');
          return;
        }
        if (this.billdate == null || this.billdate == '') {
          toast.error('Please enter a valid Bill Date');
          return;
        }
        if (cs.isvalidDate(this.billdate) == false) {
          toast.error('Invalid Bill Date');
          return;
        }
        
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        
        this.isButtonDisabled = true
        const billdate = cs.ConvertToISODate(this.billdate);
        const response = await axios.get('/update_billdate?billdate=' + billdate + '&billno=' + billno, config);
        console.log(response)
        toast.success(response.data[1]);
        this.getReportDetails(billno)
      } catch (error) {
        console.error('Error updating bill date:', error);
        toast.error(error.response?.data?.message || 'Error updating bill date.');
      } finally {
        this.isButtonDisabled = false
      }
    },
    async UpdateBillRoundOffStatus(billno) {
      if (this.isSubmitting) return;
      
      const toast = useToast();
      
      try {
        if (this.billno == null || this.billno == '') {
          toast.error('Please enter a valid Bill No');
          return;
        }
        
        const token = localStorage.getItem('access_token');
        if (!token) {
          toast.error('Authentication token not found.');
          return;
        }
        
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        
        this.isButtonDisabled = true
        
        const response = await axios.get('/update_billroundoffstatus?chkround=' + this.isRound + '&billno=' + billno, config);
        console.log(response)
        toast.success(response.data[1]);
        this.getReportDetails(billno)
      } catch (error) {
        console.error('Error updating round-off status:', error);
        toast.error(error.response?.data?.message || 'Error updating round-off status.');
      } finally {
        this.isButtonDisabled = false
      }
    },
    resetForm() {
      if (this.isSubmitting) return;
      
      this.formData = {
        applicantid: 0,
        accountid: 0,
        partyname: 0,
        fromdate: '',
        todate: '',
        contnumber: '',
        reporttype: 0
      };
      this.bills = [];
      useToast().success('Form reset successfully!');
    }
  },
  mounted() {
    this.getBills(); // Fetch bills on component mount
  }
};
</script>
<style scoped>
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;

}

.container {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 5px;
  width: 22%;
  padding: 5px;
  float: left;
}

label {
  display: block;
  margin-bottom: 5px;
}

select,
input[type="text"],
input[type="date"] {
  width: 90%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input::placeholder {
  color: #888;
}

.excel-button,
.generate-button,
.cancel-button1 {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
}

.excel-button {
  background-color: #17a2b8;
}

.cancel-button1 {
  background-color: #dc3545;
}

.excel-button:disabled,
.cancel-button1:disabled,
.export-button:disabled,
.pdf-button:disabled,
.edit-button:disabled,
.cancel-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.excel-button:disabled:hover,
.cancel-button1:disabled:hover,
.export-button:disabled:hover,
.pdf-button:disabled:hover,
.edit-button:disabled:hover,
.cancel-button:disabled:hover {
  background-color: #6c757d;
}

button:hover {
  opacity: 0.9;
}

.excel-button:disabled,
.cancel-button1:disabled,
.export-button:disabled,
.pdf-button:disabled,
.edit-button:disabled,
.cancel-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.excel-button:disabled:hover,
.cancel-button1:disabled:hover,
.export-button:disabled:hover,
.pdf-button:disabled:hover,
.edit-button:disabled:hover,
.cancel-button:disabled:hover {
  background-color: #6c757d;
}

.date-range {
  display: flex;
  justify-content: space-between;
}

.date-range label {
  flex: 1;
  margin: 0 10px;
}

.date-range input {
  flex: 2;
}

.print-button {
  background-color: rgb(50, 89, 187);
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 32px;
  position: relative;
  margin-left: 10px;
}

.export-button {
  background-color: rgb(50, 89, 187);
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;
  margin-left: 10px;
}

.print-button:hover,
.export-button:hover {
  background-color: rgb(30, 60, 150);
}

.export-options {
  display: none;
  position: absolute;
  top: 40px;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.export-button:hover .export-options {
  display: block;
}

.export-options li {
  padding: 8px 12px;
  cursor: pointer;
}

.export-options li:hover {
  background-color: #f1f1f1;
}

.table-container {
  overflow-x: auto;
}

.transaction-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.transaction-table th,
.transaction-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.transaction-table th {
  cursor: pointer;
  background-color: #f4f4f4;
}

.transaction-table tr:hover {
  background-color: #f9f9f9;
}

.bottom-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rows-per-table {
  display: flex;
}

.rows-per-table button {
  margin-right: 5px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 20px;
  cursor: pointer;
  background-color: #fff;
}

.rows-per-table button.active {
  background-color: #007bff;
  color: white;
}

.pagination {
  display: flex;
}

.page-number {
  margin: 0 5px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 20px;
  cursor: pointer;
}

.page-number.active {
  background-color: #007bff;
  color: white;
}

/* Overlay container */
.edit-overlay {
  position: fixed;
  /* Ensures the overlay stays above all other content */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  /* Enables scrolling if the content exceeds viewport height */
  z-index: 9999;
  /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  /* Adjusted width for better fit */
  /*max-width: 1000px;*/
  /* Adjusted max-width */
  max-height: 90vh;
  /* Limits the height to prevent overflow */
  overflow-y: auto;
  /* Enables vertical scrolling within the content */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  margin-top: 50px;
  /* Adds margin from the top */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}
</style>
